import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// hero-8.twig
import React from 'react';
import styled, { css } from 'styled-components';
import { contextualSpaces, workshops, ButtonAdapter, Content, Headline, LazyImageAdapter } from '@miro-site/components_utils';
import { Section, Video, Box, useWindowScroll } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WORKSHOPS_BG_COLORS = workshops.WORKSHOPS_BG_COLORS;
var SECTION_STYLES = {
  position: 'relative',
  overflow: 'hidden',
  marginBottom: [48, 88]
};
var Row = styled(Box).attrs({
  $my: [null, 0],
  $mx: [null, -10]
}).withConfig({
  displayName: "HeroFirstLevel__Row",
  componentId: "sc-1mztzco-0"
})(["display:flex;flex-wrap:wrap;flex-direction:row;.hero-button{", "}"], function (_ref) {
  var theme = _ref.theme;
  return css(["", ""], theme.mq.small(css(["margin-top:", "px;"], theme.spaces.lg)));
});
var Col = styled(Box).attrs(function (_ref2) {
  var $isSecond = _ref2.$isSecond;
  var boxProps = {
    $py: [null, 0],
    $px: [null, 10],
    $styles: {
      width: ['100%', '50%']
    }
  };

  if ($isSecond) {
    boxProps.$pt = [64, 12];
  }

  return boxProps;
}).withConfig({
  displayName: "HeroFirstLevel__Col",
  componentId: "sc-1mztzco-1"
})(["flex:0 0 50%;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return css(["", ""], theme.mq.small(css(["flex:0 0 100%;"])));
});
var ImagesSection = styled(Box).attrs({
  $mt: [40, 80],
  $py: [39, null, null, null],
  $px: [20, null, null, null],
  $styles: {
    margin: '0 auto',
    maxWidth: [null, 1430]
  }
}).withConfig({
  displayName: "HeroFirstLevel__ImagesSection",
  componentId: "sc-1mztzco-2"
})(["position:relative;overflow:hidden;"]);
var ImagesContainer = styled(Box).attrs({
  $px: [null, 0],
  $pt: [null, 120],
  $pb: [null, 80]
}).withConfig({
  displayName: "HeroFirstLevel__ImagesContainer",
  componentId: "sc-1mztzco-3"
})(["", ""], function (_ref4) {
  var $setOffsetTop = _ref4.$setOffsetTop;
  return $setOffsetTop && css(["padding-top:0;"]);
});
var Shape = styled(Box).attrs({
  $styles: {
    width: [365, 1430]
  }
}).withConfig({
  displayName: "HeroFirstLevel__Shape",
  componentId: "sc-1mztzco-4"
})(["height:auto;position:absolute;top:0;left:50%;transform:translateX(-50%);"]);
var ImageContainer = styled(Box).attrs({
  $styles: {
    width: ['100%', 1120],
    borderRadius: [4, 8]
  }
}).withConfig({
  displayName: "HeroFirstLevel__ImageContainer",
  componentId: "sc-1mztzco-5"
})(["display:block;height:auto;margin:0 auto;position:relative;z-index:3;overflow:hidden;", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return css(["", " ", " ", " ", ""], theme.mq.small(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.small(8), theme.multipliers.small(24))), theme.mq.mediumDown(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.mediumDown(8), theme.multipliers.mediumDown(24))), theme.mq.mediumUp(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.mediumUp(8), theme.multipliers.mediumUp(24))), theme.mq.large(css(["box-shadow:0 ", " ", " rgba(5,0,56,0.12);"], theme.multipliers.large(8), theme.multipliers.large(24))));
});
var VideoContainer = styled(Box).attrs({
  $styles: {
    borderRadius: [2, 8],
    width: [null, 1120]
  }
}).withConfig({
  displayName: "HeroFirstLevel__VideoContainer",
  componentId: "sc-1mztzco-6"
})(["margin:0 auto;position:relative;z-index:3;overflow:hidden;"]);

var getHeadline = function getHeadline(headlineProps) {
  var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  Object.assign(headlineProps, {
    size: headlineProps.size || 'medium',
    tag: headlineProps.tag || 'h1',
    color: workshops.isHighContrastColor(background) ? 'white' : headlineProps.color,
    align: headlineProps.align || 'left'
  });
  return /*#__PURE__*/_jsx(Headline, _objectSpread({}, headlineProps));
};

var ScrollContainer = styled.div.withConfig({
  displayName: "HeroFirstLevel__ScrollContainer",
  componentId: "sc-1mztzco-7"
})(["height:100%;overflow:hidden;"]);
var DEFAULT_SHAPE_SIZES = {
  desktop: {
    width: 1430,
    height: 845
  },
  mobile: {
    width: 365,
    height: 340
  }
};

var HeroFirstLevel = function HeroFirstLevel(_ref6) {
  var _shape$desktop, _image$desktop, _shape$desktop2, _shape$mobile;

  var headline = _ref6.headline,
      _ref6$background = _ref6.background,
      background = _ref6$background === void 0 ? 'workshops-color-grey' : _ref6$background,
      button = _ref6.button,
      content = _ref6.content,
      shape = _ref6.shape,
      image = _ref6.image,
      video = _ref6.video;
  var ref = React.useRef(null);
  var textColor = workshops.isHighContrastColor(background) ? 'white' : background == '' ? 'dark' : null;
  useWindowScroll(function () {
    if (!ref.current) {
      return;
    }

    ref.current.scrollTop = window.pageYOffset;
  });
  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Hero Section",
    $styles: SECTION_STYLES,
    $noPaddingTop: true,
    $noPaddingBottom: true,
    type: "large",
    background: background && WORKSHOPS_BG_COLORS[background],
    children: /*#__PURE__*/_jsxs(ScrollContainer, {
      ref: ref,
      children: [/*#__PURE__*/_jsx(Box, {
        $pt: [40, 120],
        $px: [20, null],
        $styles: {
          maxWidth: [null, 1120],
          margin: 'auto',
          position: 'relative'
        },
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            children: [(headline === null || headline === void 0 ? void 0 : headline.text) && getHeadline(headline, background), button && /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({
              $styles: {
                marginTop: contextualSpaces.buttonSpaces.afterText.common
              },
              "class": "hero-button"
            }, button), {}, {
              type: !background || background == 'workshops-color-grey' ? 'blue' : 'white'
            }))]
          }), /*#__PURE__*/_jsx(Col, {
            $isSecond: true,
            children: content && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, content), {}, {
              color: textColor || content.color
            }))
          })]
        })
      }), /*#__PURE__*/_jsx(ImagesSection, {
        children: /*#__PURE__*/_jsxs(ImagesContainer, {
          $setOffsetTop: !!(!(shape !== null && shape !== void 0 && (_shape$desktop = shape.desktop) !== null && _shape$desktop !== void 0 && _shape$desktop.src) && image !== null && image !== void 0 && (_image$desktop = image.desktop) !== null && _image$desktop !== void 0 && _image$desktop.src),
          children: [shape && /*#__PURE__*/_jsx(Shape, {
            children: /*#__PURE__*/_jsx(LazyImageAdapter, {
              assets: {
                desktop: shape !== null && shape !== void 0 && (_shape$desktop2 = shape.desktop) !== null && _shape$desktop2 !== void 0 && _shape$desktop2.src ? _objectSpread(_objectSpread({}, DEFAULT_SHAPE_SIZES.desktop), shape.desktop) : undefined,
                mobile: shape !== null && shape !== void 0 && (_shape$mobile = shape.mobile) !== null && _shape$mobile !== void 0 && _shape$mobile.src ? _objectSpread(_objectSpread({}, DEFAULT_SHAPE_SIZES.mobile), shape.mobile) : undefined
              }
            })
          }), image && /*#__PURE__*/_jsx(ImageContainer, {
            children: /*#__PURE__*/_jsx(LazyImageAdapter, {
              assets: image
            })
          }), video && /*#__PURE__*/_jsx(VideoContainer, {
            children: /*#__PURE__*/_jsx(Video, {
              id: video.id,
              thumbnail: video.thumbnail
            })
          })]
        })
      })]
    })
  });
};

export default HeroFirstLevel;